import { useEffect } from 'react';

/** Landing page for MPGS hosted checkout redirects. Runs in the popup window. */
export default function PayReturn() {
  useEffect(() => {
    const t = setTimeout(() => window.close(), 3000);
    return () => clearTimeout(t);
  }, []);
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 text-slate-100">
      <div className="text-center space-y-3 p-8">
        <div className="text-5xl">✓</div>
        <h1 className="text-xl font-semibold">Payment complete</h1>
        <p className="text-slate-400 text-sm">You can close this window and return to the POS.</p>
      </div>
    </div>
  );
}
